import { render, staticRenderFns } from "./EnsembleRoster.vue?vue&type=template&id=3bc4fc10&scoped=true&"
import script from "./EnsembleRoster.vue?vue&type=script&lang=js&"
export * from "./EnsembleRoster.vue?vue&type=script&lang=js&"
import style0 from "./EnsembleRoster.vue?vue&type=style&index=0&id=3bc4fc10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4fc10",
  null
  
)

export default component.exports